// src/features/tasks/components/TaskListPage/TasksDataGrid/utils/dataGridUtils.js
export const dataGridStyles = {
  // Override default row height constraints
  '& .MuiDataGrid-row': {
    cursor: 'pointer',
    minHeight: 'unset !important',
    maxHeight: 'none !important',
    '&:hover': {
      backgroundColor: 'action.hover',
    },
  },

  '& .no-padding-cell': {
    padding: "0 !important"
  },

  '& .MuiDataGrid-cell': {
    minHeight: 'unset !important',
    maxHeight: 'none !important',
    height: 'auto !important',
    display: 'flex !important',
    alignItems: 'center !important',
    lineHeight: '1.5 !important',
    padding: '12px 16px !important',
  },
  
  // Custom row styling based on task state
  '& .row-overdue': {
    boxShadow: (theme) => `inset 4px 0 0 ${theme.palette.error.main}`,
    backgroundColor: (theme) => `${theme.palette.error.main}20 !important`, //'rgba(255, 235, 238, 0.3) !important',
    '&:hover': {
      backgroundColor: (theme) => `${theme.palette.error.light}10 !important`,
    },
  },
  
  '& .row-scheduled': {
    boxShadow: (theme) => `inset 4px 0 0 ${theme.palette.info.main}`,
    backgroundColor: 'rgba(227, 242, 253, 0.3)',
  },
  
  '& .row-completed, .row-cancelled': {
    opacity: 0.7,
    backgroundColor: 'rgba(0, 0, 0, 0.02)',
    '& .MuiDataGrid-cell': {
      color: 'text.secondary',
    },
  },
  
  // Toolbar and header styling
  '& .MuiDataGrid-columnHeaderTitle': {
    fontWeight: 'bold',
  },
  '& .MuiDataGrid-toolbarContainer': {
    borderBottom: '1px solid',
    borderBottomColor: 'divider',
    padding: 1,
  },
  
  // Animation keyframes for overdue tasks
  '@keyframes pulse': {
    '0%': { opacity: 1 },
    '50%': { opacity: 0.7 },
    '100%': { opacity: 1 },
  },
  '@keyframes shake': {
    '0%': { transform: 'translateX(0)' },
    '25%': { transform: 'translateX(-2px)' },
    '50%': { transform: 'translateX(2px)' },
    '75%': { transform: 'translateX(-1px)' },
    '100%': { transform: 'translateX(0)' },
  },
  
  // Fix virtualization with auto height
  '& .MuiDataGrid-virtualScrollerRenderZone .MuiDataGrid-row': {
    maxHeight: 'none !important',
  },
  '& .MuiDataGrid-renderingZone .MuiDataGrid-row': {
    maxHeight: 'none !important',
  },
  
  // Quick actions opacity control
  '& .MuiIconButton-root': {
    opacity: 0.8,
    transition: 'opacity 0.2s ease-in-out',
  },
  '& .MuiDataGrid-row:hover .MuiIconButton-root': {
    opacity: 1,
  },
};